import { ofType } from 'redux-observable';
import { ajax } from 'rxjs/ajax';
import { of } from 'rxjs';
import { map, switchMap, catchError } from 'rxjs/operators';
import { organisationTabCriteria, boundariesCriteria } from '../../../utilities/epic-helpers';

import {
  FETCH_MOBILE_DEVICES_REPORT,
  FETCH_MOBILE_DEVICES_REPORT_ERROR,
  SET_FETCH_MOBILE_DEVICES_REPORT
} from '../../constants';

const mobileDevicesReport = (action$, state$) =>
  action$.pipe(
    ofType(FETCH_MOBILE_DEVICES_REPORT),
    switchMap(() =>
      ajax({
        url: `${state$.value.auth.server}/report/mobile-devices/devices?${
          organisationTabCriteria(state$)
        }${
          boundariesCriteria(state$)
        }&v=${process.env.REACT_APP_VERSION}`,
        headers: {
          Authorization: state$.value.auth.token,
        },
        responseType: 'json',
        crossDomain: true,
      }).pipe(
        map(response => {

          return {
            type: SET_FETCH_MOBILE_DEVICES_REPORT,
            data: response.response,
          };
        }),
        catchError(error =>
          of({
            type: FETCH_MOBILE_DEVICES_REPORT_ERROR,
            error,
          })
        )
      )
    )
  );

export default mobileDevicesReport;
